import React, { useEffect, useState } from "react";
import Header from "../../component/users/Header";
import { useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Box,
  Typography,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import HomeSkeleton from "../../component/users/Home/Skeleton";
import Footer from "../../component/users/Footer";
import { Add } from "@mui/icons-material";
import AddGoalForm from "../../component/users/AddGoal/AddGoalForm";
import LoaderLayout from "../../component/users/LoaderLayout";
import LoaderLayout2 from "../../component/users/LoaderLayout2";
import { getGoal } from "../../api/getGoal";
import { authenticateUser } from "../../helper/authentication";
import { toast } from "react-toastify";

const AddGoal = () => {
  const userData = useSelector((state) => state.loggedUser.user);
  const user = useSelector((state) => state.user.loading);
  const urlparam = useParams();
  const token = useSelector((state) => state.auth.token);
  const [editGoalLoading, setEditGoalLoading] = useState(true);
  const [editGoalDetails, setEditGoalDetails] = useState(null);
  const navigate = useNavigate();

  const fetchEditGoalDetails = async (id) => {
    try {
      const response = await getGoal(id, token);
      if (response.success) {
        setEditGoalDetails(response.data);
        setEditGoalLoading(false);
      } else {
        toast.error(response.message);
        navigate("/");
      }
    } catch (error) {
      toast.error("error while getting goal data");
      setEditGoalLoading(false);
      navigate("/");
    }
  };

  useEffect(() => {

    if (urlparam.id) {
      fetchEditGoalDetails(urlparam.id);
    } else {
      setEditGoalLoading(false);
      toast.error("no id found of goal");
    }
  }, []);

  return (
    <>
      <Header />

      {user ? (
        <LoaderLayout />
      ) : !editGoalLoading ? (
        <Box className="userLayout addGoal">
          <Container
            disableGutters={true}
            maxWidth="lg"
            sx={{ background: "#242743" }}
          >
            <Box className="addGoal-wrapper addTournament-wrapper">
              <AddGoalForm editGoalDetails={editGoalDetails} />
            </Box>
          </Container>
          <Footer />
        </Box>
      ) : (
        <LoaderLayout2 />
      )}
    </>
  );
};

export default AddGoal;
